import * as Yup from "yup";

export const authorizationToReleaseValidations = (section, formSpec) => {

    if (section.active) {
        return Yup.object().shape({


            facilitySelected: (formSpec.context.organization.includes('7229') || formSpec.context.organization.includes('7342') || formSpec.context.organization.includes('7307')) && Yup.string()
                .required(
                    () =>
                        true &&
                        'Please provide the name and address of at least one medical provider'
                ),

            facilitiesGroup: Yup.array().transform(value =>
                typeof value === 'string'
                    ? [value]
                    : value,
            ).min(1,

                section.fields.facilitiesGroup.validations.required.message
            ),

            tripartiteOrgFacLength: Yup.number().when("tripartiteOrgFacility", {
                is: val => val === true,
                then: schema => schema.min(2, "Please select at least one facility."),

            }),




            selectedOutpatientCliniclocations: Yup.array().when("outPatientSelected", {
                is: val => val === true,
                then: schema => schema.required("When 'Outpatient Clinic locations' is selected, you will need to select at least one outpatient location.").min(1, "When 'Outpatient Clinic locations' is selected, you will need to select at least one outpatient location.")
            }),

            selectedLongTermCarelocations: Yup.array().when("longTermSelected", {
                is: val => val === true,
                then: schema => schema.required("When 'Long-Term Care locations' is selected, you will need to select at least one long term location.").min(1, "When 'Long-Term Care locations' is selected, you will need to select at least one long term location.")
            }),




            allOrNameGroup: Yup.string().when("physiciansGroup", {
                is: val => val.length === 1,
                then: schema => schema.required(
                    section.fields.allOrNameGroup.validations.required
                        .message
                )
            }),
            namedPhysicians: Yup.string().when("allOrNameGroup", {
                is: val => val === "namePhysicians",
                then: schema => schema.required(
                    section.fields.namedPhysicians.validations.required.message
                )
            }),
            otherFac: Yup.string().when("facilitiesGroup", {
                is: val => val == "otherFac",
                then: schema => schema.required("When other facility is selected, please enter information into the text field or select a different option.")
            })
        });
    } else {
        return Yup.object().shape();
    }
};
